import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MenuAction } from 'src/app/models/menuAction.model';

@Component({
  selector: 'app-actions-menu-icon',
  templateUrl: './actions-menu-icon.component.html',
  styleUrls: ['./actions-menu-icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ActionsMenuIconComponent {
  @Input() public actions: MenuAction[] = [];
  @Input() public smallSize = false;
  @Output() public actionOnClick = new EventEmitter<MenuAction>();

  public onClick(action: MenuAction): void {
    if (!action.disabled) {
      this.actionOnClick.emit(action);
    }
  }
}
